import { render, staticRenderFns } from "./Marquee.vue?vue&type=template&id=47f4b1ed&scoped=true&"
import script from "./Marquee.vue?vue&type=script&lang=js&"
export * from "./Marquee.vue?vue&type=script&lang=js&"
import style0 from "./Marquee.vue?vue&type=style&index=0&id=47f4b1ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f4b1ed",
  null
  
)

export default component.exports